// axiosInstance.js

import axios from "axios";
import { apiUrl } from "./url";
import useAuthStore from "../../store/useAuthStore";
import { getCookie } from "../../shared/utils/CookieUtils";

let refreshPromise = null;

const api = axios.create({
  baseURL: apiUrl,
  timeout: 1200000,
  withCredentials: true, // IMPORTANT for cookies
  headers: {
    "Content-Type": "application/json",
  },
});

// =============================
// RESPONSE INTERCEPTOR
// =============================
api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    // Prevent infinite loop
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/refresh-token")
    ) {
      originalRequest._retry = true;

      try {
        // Prevent multiple refresh API calls
        if (!refreshPromise) {
          console.log("Refreshing access token...");

          refreshPromise = axios.post(
            `${apiUrl}v1/auth/refresh-token`,
            {},
            {
              withCredentials: true, // send refreshToken cookie
            }
          );
        }

        // Wait for refresh request
        await refreshPromise;

        // Clear refresh promise
        refreshPromise = null;

        // Retry original failed request
        return api(originalRequest);

      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);

        refreshPromise = null;

        // Logout user
        useAuthStore.getState().logout?.();

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// =============================
// EXTERNAL API
// =============================
export const externalApi = axios.create({
  baseURL: "http://100.77.240.67:8000/",
 timeout: 300000
});

api.interceptors.request.use(
  (config) => {
    const token = getCookie('access_token') || useAuthStore.getState().token;

    if (token) {
      config.headers = {
        ...config.headers,        // keep existing headers
        Authorization: `Bearer ${token}`, // force add
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);


export default api;

